import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React, { useState } from 'react';
import {
    SelectionParticipantName,
    SelectionItemStyle,
} from 'src/domains/sportsbook/webview/components/Selection/Selection.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionState } from 'src/domains/sportsbook/webview/components/Selection/Selection.state';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { LockIcon } from 'src/ui/assets/icons/other/LockIcon';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    selectionId: SelectionId | undefined;
    sp?: boolean;
    participantName?: string | null;
    borderTop?: boolean;
    borderRight?: boolean;
    borderBottom?: boolean;
    borderLeft?: boolean;
    className?: string;
    forceSuspended?: boolean;
}

export const Selection = observer('Selection', (propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);
    const { participantName = null, borderTop, borderRight, borderBottom, borderLeft, className } = props;
    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const unifiedComponentConfig = ConfigComponents.get(common).unifiedComponentConfig;
    const sdkCustomer = SdkCustomer.get(common);
    const { betSlipState } = appSportsBookState;

    const [state] = useState(() => new SelectionState(betSlipState, props, sdkCustomer));
    // TODO: [Genius] To remove this check and leave only componentVariants.eventRowVariant when GLOB-37 is fully live
    const {
        componentVariants: { selectionVariant },
        unifiedSportEventsTable,
    } = unifiedComponentConfig;

    if (state.selectionView === null) {
        return (
            <SelectionItemStyle
                borderBottom={borderBottom}
                borderLeft={borderLeft}
                borderRight={borderRight}
                borderTop={borderTop}
                className={`${className === undefined ? '' : className} selection no-selection`}
                href='#'
                onClick={state.chooseNew}
                variant={selectionVariant}
            >
                -
            </SelectionItemStyle>
        );
    }

    const showParticipantName = typeof participantName === 'string';
    const { priceChange, suspended, price } = state.selectionView;
    const isSuspended = suspended || state.forceSuspended;
    const isEmpty = price === undefined;

    const selectionId: string | number | undefined =
        price === 'sp' ? `sp-${props.selectionId?.toOldId() ?? 'id-undefined'}` : props.selectionId?.toOldId();

    const renderSelectionContent = () => {
        if (isSuspended) {
            return unifiedSportEventsTable ? <LockIcon className='selection-suspended--icon' /> : null;
        }

        return state.getOddsValue;
    };

    return (
        <SelectionItemStyle
            href='#'
            data-test-selection-id={selectionId}
            onClick={state.chooseNew}
            className={`selection ${className === undefined ? '' : className}`}
            isSelected={state.isSelected}
            isSuspended={isSuspended}
            isEmpty={isEmpty}
            isOddsUp={priceChange === 'up'}
            isOddsDown={priceChange === 'down'}
            isShowParticipantName={showParticipantName}
            borderTop={borderTop}
            borderRight={borderRight}
            borderBottom={borderBottom}
            borderLeft={borderLeft}
            data-test='selection-item'
            variant={selectionVariant}
        >
            {showParticipantName ? <SelectionParticipantName>{participantName}</SelectionParticipantName> : null}
            {renderSelectionContent()}
        </SelectionItemStyle>
    );
});
